module.exports = __webpack_public_path__ + "static/img/yd.a1e1a3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skin/images/yd.jpg
// module id = ehiu
// module chunks = 20